import { ValueType } from '../../../../Utils/Formatters/FormatterTypes';
import EDTypography from '../../../../BaseComponents/Typography/EDTypography';
import { DisplayCompType } from '../Const/BusinessConfigs';

// Skapar en displaycomp rödmarkerar vissa värden
export const displayErrorValues =
  (errorValues: readonly ValueType[]): DisplayCompType =>
  props =>
    (
      <EDTypography
        variant="inherit"
        color={errorValues.includes(props.value) ? 'error' : 'initial'}
      >
        {props.displayValue}
      </EDTypography>
    );
